// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, RecaptchaVerifier } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDQn9kjeXNt8SZ3ghCX40GhwtBaKRiYc8k",
  authDomain: "pvc-cards.firebaseapp.com",
  projectId: "pvc-cards",
  storageBucket: "pvc-cards.firebasestorage.app",
  messagingSenderId: "308394367214",
  appId: "1:308394367214:web:06d8b4a045a4b41852bbff",
  measurementId: "G-24MW4HF11P",
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);

const secondaryApp = initializeApp(firebaseConfig, "Secondary");
const secondaryAuth = getAuth(secondaryApp);
const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);

const db = getFirestore(app);
export { db, auth, secondaryAuth, googleProvider, RecaptchaVerifier, storage };
